var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_-_map",
    "data-name": "icon - map",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_215",
    "data-name": "Rectangle 215",
    width: 26,
    height: 26,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2193",
    "data-name": "Path 2193",
    d: "M13,23.853a.816.816,0,0,1-.468-.148c-1.333-.923-7.985-5.8-7.985-11a8.452,8.452,0,0,1,16.9,0c0,5.2-6.651,10.077-7.985,11a.813.813,0,0,1-.467.148m0-19A7.862,7.862,0,0,0,5.147,12.7c0,4.905,6.437,9.613,7.727,10.507a.213.213,0,0,0,.252,0c1.29-.894,7.727-5.6,7.727-10.507A7.862,7.862,0,0,0,13,4.853m3.78,12.376a.2.2,0,0,0,.2-.2V11.887a1.162,1.162,0,0,1-.558-.34,1.216,1.216,0,0,1-1.711,0,1.213,1.213,0,0,1-1.71,0,1.221,1.221,0,0,1-1.713,0,1.219,1.219,0,0,1-1.71,0,1.16,1.16,0,0,1-.558.339v5.142a.2.2,0,0,0,.2.2h3.649v-3.5a.3.3,0,0,1,.3-.3h2.519a.3.3,0,0,1,.3.3v3.5Zm-1.392-3.2H13.469v3.2h1.919ZM8.42,11.886a1.1,1.1,0,0,1-.313-.141,1.146,1.146,0,0,1-.364-1.46l.9-1.872a.923.923,0,0,1,.749-.4h7.216a.908.908,0,0,1,.712.341l.937,1.93a1.146,1.146,0,0,1-.363,1.459,1.121,1.121,0,0,1-.314.142v5.143a.8.8,0,0,1-.8.8H9.22a.8.8,0,0,1-.8-.8Zm6.291-1.307a.315.315,0,0,1,.3.26.556.556,0,0,0,1.1.008.317.317,0,0,1,.3-.267h0a.314.314,0,0,1,.3.26.555.555,0,0,0,.609.483.517.517,0,0,0,.229-.081.553.553,0,0,0,.15-.7l-.9-1.872a.426.426,0,0,0-.208-.059H9.392a.314.314,0,0,0-.245.117l-.863,1.814a.551.551,0,0,0,.151.7.505.505,0,0,0,.227.081.55.55,0,0,0,.609-.476.314.314,0,0,1,.305-.267h0a.316.316,0,0,1,.3.263.555.555,0,0,0,1.1,0,.309.309,0,0,1,.314-.267.315.315,0,0,1,.3.276.556.556,0,0,0,1.1-.009.308.308,0,0,1,.61-.007.556.556,0,0,0,1.1.007.315.315,0,0,1,.3-.267h.007"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMap);
export default __webpack_public_path__ + "static/media/icon-map.992f2cfc0b4fccb0b21ddb9e653dd936.svg";
export { ForwardRef as ReactComponent };